"use client";

import { useUser } from "@clerk/clerk-react";
import { loadConnectAndInitialize } from "@stripe/connect-js";
import { ConnectAccountOnboarding, ConnectComponentsProvider } from "@stripe/react-connect-js";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { apiClient } from "../lib/apiClient";

// Stripe Account interface for TypeScript support
interface StripeAccount {
	id: string;
	requirements?: {
		eventually_due?: string[];
		currently_due?: string[];
		past_due?: string[];
	};
	charges_enabled?: boolean;
	payouts_enabled?: boolean;
	details_submitted?: boolean;
	[key: string]: unknown; // Allow other Stripe properties
}

export default function Onboarding() {
	const navigate = useNavigate();
	const params = useParams<{ accountId: string }>();
	const { user } = useUser();

	const [stripeConnectInstance] = useState(() => {
		const fetchClientSecret = async (): Promise<string> => {
			const result = await apiClient().post<{ clientSecret: string }>("/connect/session", {
				accountId: params.accountId,
			});
			console.log(result);
			return result.data.clientSecret;
		};

		return loadConnectAndInitialize({
			publishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY as string,
			fetchClientSecret: fetchClientSecret,
		});
	});

	const handleOnExit = async () => {
		try {
			const result = await apiClient().get<StripeAccount>(`/connect/status/${user?.id}`);

			const account = result.data;
			const currentlyDue = account.requirements?.currently_due || [];

			if (currentlyDue.length === 0) {
				navigate("/");
			}
		} catch (error) {
			console.error("Error checking onboarding status:", error);
		}
	};

	return stripeConnectInstance ? (
		<div className="md:h-screen m-2 md:mx-auto md:w-2xl">
			<ConnectComponentsProvider connectInstance={stripeConnectInstance}>
				<div className="sm:px-5 lg:px-14 max-w-xl mx-auto">
					<ConnectAccountOnboarding
						onExit={handleOnExit}
						// Optional: make sure to follow our policy instructions above
						fullTermsOfServiceUrl="https://app.termly.io/policy-viewer/policy.html?policyUUID=a95653c1-e6b7-49f7-9a37-93b68c565771"
						recipientTermsOfServiceUrl="https://app.termly.io/policy-viewer/policy.html?policyUUID=a95653c1-e6b7-49f7-9a37-93b68c565771"
						privacyPolicyUrl="https://app.termly.io/policy-viewer/policy.html?policyUUID=42b95b44-da0b-42d9-922c-2efa1118f9ab"
						skipTermsOfServiceCollection={false}
						collectionOptions={{
							fields: "eventually_due",
							futureRequirements: "include",
						}}
						// onStepChange={(stepChange) => {
						//   console.log(`User entered: ${stepChange.step}`);
						// }}
					/>
				</div>
			</ConnectComponentsProvider>
		</div>
	) : null;
}
